// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ConnectionQuality__icon-e2bc48 {
  margin-inline-end: 6px;
}

:root[dir=rtl] .ConnectionQuality__icon-e2bc48 {
  transform: scaleX(-1);
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/Shared/CallState/ConnectionQuality/ConnectionQuality.styles.m.css"],"names":[],"mappings":"AAAA;EACE,sBAAA;AACF;;AAEA;EACE,qBAAA;AACF","sourcesContent":[".icon {\n  margin-inline-end: 6px;\n}\n\n:root[dir='rtl'] .icon {\n  transform: scaleX(-1);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `ConnectionQuality__icon-e2bc48`
};
module.exports = ___CSS_LOADER_EXPORT___;
